export default __webpack_public_path__ + "static/media/gallery.85cd1fe5.gif";